import appStateUpdator from '@/store/AppStateUpdator';

const projectCountInfoService = {
	updateProjectCountStore(projectCount: number) {
		appStateUpdator.updateProjectCount(projectCount);
	},
	deleteProjectCountStore() {
		appStateUpdator.deleteProjectCount();
	},
	getProjectCountStore(): number | null {
		return appStateUpdator.getProjectCount();
	}
};

export default projectCountInfoService;
